import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LoadContainers_ds_carrier_service_types_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, carrierId: number }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrierId)) {
      missingRequiredInParams.push('\'carrierId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_carrier_service_types_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, carrierId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrierId)) {
      missingRequiredInParams.push('\'carrierId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_carrier_service_types_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, carrierId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.carrierId)) {
      missingRequiredInParams.push('\'carrierId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_carrier_service_types_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string, carrierId: number    }) {
        if(isNil(inParams.carrierId)) {
          return true; 
        }
      return false;
    }
}
